import { Outlet } from "react-router-dom";
import ContainerAside from "./Aside/Container";
import ContainerHeader from "./Header/Container";

export default function AppShell() {
  return (
    <div className="w-dvw h-dvh overflow-hidden flex flex-col bg-zi-bg1-light dark:bg-zi-bg1-dark">
      <ContainerHeader />
      <div className="flex-1 overflow-hidden flex p-2.5 gap-2.5">
        <ContainerAside />
        <Outlet />
      </div>
    </div>
  );
}
